import React from 'react'
import { Controller, ControllerProps } from 'react-hook-form'
import {
  IAutocompleteBaseOption,
  IConstructedStopFacility,
} from 'transfix-ui/components/AutocompleteBase'
import {
  AutocompleteFacility,
  IAutocompleteFacilityProps,
} from 'transfix-ui/components/AutocompleteFacility'

type IBaseControllerProps = ControllerProps<React.ComponentType<IAutocompleteFacilityProps>>

export interface IControlledAutocompleteFacilityProps
  extends Pick<IBaseControllerProps, 'defaultValue' | 'control'> {
  name: string
  /**
   * Sets required variable for GraphQL query
   * @example '231'
   */
  shipperApplicationId: string
  onChangeFacility?: (value: IConstructedStopFacility | null) => void
  shipperFacility?: IAutocompleteFacilityProps['shipperFacility']
  AutocompleteFacilityProps?: Partial<IAutocompleteFacilityProps>
  transform?: (value: Pick<IAutocompleteBaseOption, 'id' | 'text'>) => unknown
}

const ControlledAutocompleteFacility = ({
  control,
  defaultValue,
  name,
  shipperApplicationId,
  shipperFacility,
  onChangeFacility,
  AutocompleteFacilityProps = {},
  transform = value => value,
}: IControlledAutocompleteFacilityProps) => {
  return (
    <Controller
      control={control}
      name={name}
      defaultValue={defaultValue}
      render={({ onChange, value }) => {
        const changeHandler: IAutocompleteFacilityProps['onChange'] = newVal => {
          if (newVal) {
            onChange(transform(newVal))
          } else {
            onChange(undefined)
          }
          if (onChangeFacility !== undefined) {
            onChangeFacility(newVal as IConstructedStopFacility)
          }
        }

        return (
          <AutocompleteFacility
            onChange={changeHandler}
            shipperApplicationId={shipperApplicationId}
            shipperFacility={shipperFacility}
            value={value}
            {...AutocompleteFacilityProps}
          />
        )
      }}
    />
  )
}

export default ControlledAutocompleteFacility
